import fetchAPI from '../fetchAPI';

export const callDeleteBillingAccount = async (
  id: string,
  options?: { forceDelete?: boolean }
): Promise<iResponse<BillingAccount>> => {
  const params = new URLSearchParams();
  if (options?.forceDelete) params.append('forceDelete', 'true');
  const queryString = params.toString();

  const response: iResponse<BillingAccount> = await fetchAPI({
    method: `DELETE`,
    route: `billing-accounts/${id}`,
    queryString: queryString || undefined
  });

  return response;
};

export default callDeleteBillingAccount;
